import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';

export default class Promo extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    pcSrc: PropTypes.string,
    mbSrc: PropTypes.string,
    link: PropTypes.shape({
      href: PropTypes.string,
      targetBlank: PropTypes.bool,
    }),
    pcLayout: PropTypes.string,
    mbLayout: PropTypes.string,
    backgroundColor: PropTypes.string,
    getRef: PropTypes.func,
    inFeatureCategoriesHorizontal: PropTypes.bool,
    hasBackground: PropTypes.bool,
    parentColumn: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcDescription: null,
    mbDescription: null,
    pcSrc: null,
    mbSrc: null,
    link: null,
    pcLayout: null,
    mbLayout: null,
    backgroundColor: null,
    getRef: null,
    inFeatureCategoriesHorizontal: false,
    hasBackground: false,
    parentColumn: null,
  };

  static imgTag(src, suffix = '', baseClass = 'Promo__image') {
    if (!src) {
      return null;
    }
    return <img src={src} alt="" className={`${baseClass} ${baseClass}${(suffix) ? '-': ''}${suffix}`}/>
  }

  static descriptionTag(description, suffix = '', baseClass = 'Promo__wysiwyg') {
    if (!description) {
      return null;
    }
    return (
      <div
        className={`${baseClass}${(suffix) ? '-': ''}${suffix}` + ' Wysiwyg'}
        dangerouslySetInnerHTML={{__html: description}}
      />
    );
  }

  /**
   * `Image-On-Left(60:40)` to `image-on-left-60_40`
   * @param {string} className `pcLayout` / `mbLayout` value
   * @returns {string} valid css name
   * @see https://www.w3.org/TR/CSS21/grammar.html#scanner
   */
  static convert(className) {
    return className.toLowerCase().replace(/[\/|:]/g, '_').replace(/[)]/g, '').replace(/[(]/g, '-');
  }

  constructor(props) {
    super(props);
    // if (this.props.hasBackground || (this.props.backgroundColor && this.props.backgroundColor !== '')) {
    //   console.log('hasBackground(Promo) : ' + true);
    // } else {
    //   console.log('hasBackground(Promo) : ' + false);
    // }
    if (this.props.getRef) this.props.getRef(this);
    this.state = {
      containerHeight: null,
      // firstStyle: props.inFeatureCategoriesHorizontal ? { opacity: 0, float: 'left', } : null,
    };
    this.refsContainer = null;
  }

  layoutClass() {
    const {
      pcLayout,
      mbLayout,
    } = this.props;
    const pcClass = pcLayout || 'Image-On-Top';
    const mbClass = mbLayout || pcClass;
    return {
      pc: `pcLayout__${Promo.convert(pcClass)}`,
      mb: `mbLayout__${Promo.convert(mbClass)}`,
    };
  };

  renderFigures() {

    const getStyle = ()=> {
      if (this.props.link && this.props.link.href && this.props.link.href !== '') {
        return null;
      } else {
        return {
          backgroundColor: 'transparent'
        }
      }
    };

    const {
      pcSrc,
      mbSrc,
    } = this.props;
    const pcImg = pcSrc || '';
    const mbImg = mbSrc || pcImg;
    if (!pcImg && !mbImg) {
      return null;
    }
    return (
      <div className="Promo__image__block" style={getStyle()}>
        {Promo.imgTag(pcImg, 'pc')}
        {Promo.imgTag(mbImg, 'mb')}
      </div>
    );
  }

  renderDescriptions() {
    const {
      pcDescription,
      mbDescription,
    } = this.props;
    const pcHtml = pcDescription || '';
    const mbHtml = mbDescription || pcHtml;
    if (!pcHtml && !mbHtml) {
      return null;
    }
    return (
      <div className="Promo__text__block">
        <div className="Promo__wysiwyg">
          {Promo.descriptionTag(pcHtml, 'pc')}
          {Promo.descriptionTag(mbHtml, 'mb')}
        </div>
      </div>
    );
  }

  getContentsHeight() {
    // console.log('getContentsHeight', this.refsContainer.clientHeight);
    // return this.refs.contents.clientHeight;
    // console.log('Promo.getContentsHeight', this.refsContainer.clientHeight, this.refsContainer.getBoundingClientRect());
    return this.refsContainer.clientHeight;
  }

  setContainerHeight(height) {
    // console.log('setContainerHeight', height);
    if (this.state.containerHeight !== height) {
      this.setState({
        containerHeight: height,
      });
    }
    // this.setState({
    //   containerHeight: height,
    // })
  }

  clearContainerHeight() {
    if (this.state.containerHeight !== null) {
      this.setState({
        containerHeight: null,
      });
    }
    // this.setState({
    //   containerHeight: null,
    // })
  }

  // componentDidMount() {
  //   const { inFeatureCategoriesHorizontal } = this.props;
  //   if (inFeatureCategoriesHorizontal) {
  //     this.setState({ firstStyle: null });
  //   }
  // }

  render() {
    const {
      containerId,
      containerClass,
      link,
    } = this.props;
    // ---
    const figures = this.renderFigures();
    const descriptions = this.renderDescriptions();
    if (!figures && !descriptions) {
      return null;
    }
    // ---
    const Link = (link && link.href) ? 'a': 'span';
    const attributes = {
      className: 'Promo__link',
    };
    if (Link === 'a') {
      attributes.href = link.href;
      if (link.targetBlank) {
        attributes.target = '_blank';
      }
    }
    // ---
    const layout = this.layoutClass();
    //
    let layout2 = null;
    if (this.props.hasBackground || (this.props.backgroundColor && this.props.backgroundColor !== '')) {
      layout2 = 'hasBackground';
      if (this.props.parentColumn === 'oneColumnLayout') {
        layout2 = 'hasBackground oneColumnLayout';
      } else if (this.props.parentColumn === 'twoColumnLayout') {
        layout2 = 'hasBackground twoColumnLayout';
      } else if (this.props.parentColumn === 'threeColumnLayout') {
        layout2 = 'hasBackground threeColumnLayout';
      } else if (this.props.parentColumn === 'fourColumnLayout') {
        layout2 = 'hasBackground fourColumnLayout';
      }
    }
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div
          className={`Promo ${layout.pc} ${layout.mb}` + ((layout2) ? ' ' + layout2 : '')}
        >
          <Link {...attributes}
                style={(this.props.backgroundColor) ? {backgroundColor: '#' + this.props.backgroundColor.replace(/#/g, '')}: null}
          >
            <div className="Promo__wrapper"
                 style={(this.state.containerHeight) ? {height: this.state.containerHeight}: null}
            >
              <div className="Promo__container"
                // ref="contents"
                   ref={component => (this.refsContainer = component)}
              >
                {figures}
                {descriptions}
              </div>
            </div>
          </Link>
        </div>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/promo/index.jsx